import { ServiceFactory } from "@rsm-hcd/javascript-react";
import RemoteAccessDetailsRecord from "models/view-models/remote-access-details-record";

export interface SharedPageRecipientAccessResourcePathParams {
    pageGuid: string;
}
export interface SharedPageRecipientAccessQueryParams {
    recipientGuid?: string;
    storageContainer?: string;
    relativeProviderPath?: string;
}

const endpoint: string = "shared/pages/:pageGuid/remoteaccessdetails";
const resourceType = RemoteAccessDetailsRecord;

const SharedPageRemoteAccessDetailsService = {
    /**
     * Get a PreSignedUrl to an S3 resource
     */
    get: ServiceFactory.get<
        RemoteAccessDetailsRecord,
        SharedPageRecipientAccessResourcePathParams,
        SharedPageRecipientAccessQueryParams
    >(resourceType, endpoint),
};

export default SharedPageRemoteAccessDetailsService;
